export const getUrlParams = () => {
    if (typeof window !== `undefined`) {
      return window.location.search
        .substr(1)
        .split("&")
        .map(el => el.split("="))
        .reduce((acc, arr) => ((acc[arr[0]] = arr[1]), acc), {})
    } else return {}
  }